import { ArrowLeft, Search, FileText, ChevronRight } from "lucide-react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { searchArticles } from "./helpCenterData";
import styles from "../HelpCenter.module.css";
import searchStyles from "./HelpSearchPage.module.css";
import Footer from "../../../ui/Footer/Footer";
const HelpSearchPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const query = params.get("q") || "";
  const results = query ? searchArticles(query) : [];

  return (
    <div className={styles.container}>
      <div className={styles.hero} style={{ padding: "2rem 2rem 1.75rem" }}>
        <div className={styles.heroInner}>
          <div className={styles.heroNav}>
            <Link to="/HelpCenter" className={styles.backLink}>
              <ArrowLeft size={16} /> Back to Help Center
            </Link>
          </div>
          <h1 className={styles.heroTitle} style={{ fontSize: "1.75rem" }}>
            {query ? `Search results for "${query}"` : "Search Help Center"}
          </h1>
          <p className={styles.heroSubtitle}>
            {results.length} {results.length === 1 ? "result" : "results"} found
          </p>
        </div>
      </div>

      <div className={styles.tabBar}>
        <Link to="/contact" className={styles.tab}>
          Contact Us
        </Link>
        <Link to="/HelpCenter" className={`${styles.tab} ${styles.tabActive}`}>
          Help Center
        </Link>
        {/* <Link to="/issues" className={styles.tab}>
          Report an Issue
        </Link> */}
      </div>

      <div className={styles.mainContent}>
        {results.length > 0 ? (
          <div className={styles.articlesList}>
            {results.map((article) => (
              <div
                key={article.id}
                className={styles.articleItem}
                onClick={() => navigate(`/HelpCenter/article/${article.id}`)}
              >
                <div className={styles.articleInfo}>
                  <div className={styles.articleIcon}>
                    <FileText size={14} />
                  </div>
                  <div className={styles.articleText}>
                    <h4>{article.title}</h4>
                    <span>
                      {article.category} · {article.readTime} read
                    </span>
                  </div>
                </div>
                <div className={styles.articleMeta}>
                  {article.badge === "new" && (
                    <span className={`${styles.badge} ${styles.badgeNew}`}>
                      New
                    </span>
                  )}
                  {article.badge === "popular" && (
                    <span className={`${styles.badge} ${styles.badgePopular}`}>
                      Popular
                    </span>
                  )}
                  {article.badge === "updated" && (
                    <span className={`${styles.badge} ${styles.badgeUpdated}`}>
                      Updated
                    </span>
                  )}
                  <ChevronRight size={16} className={styles.articleArrow} />
                </div>
              </div>
            ))}
          </div>
        ) : query ? (
          <div className={searchStyles.noResults}>
            <Search size={40} />
            <h3>No results found</h3>
            <p>
              Try different keywords or browse categories in the{" "}
              <Link to="/HelpCenter">Help Center</Link>.
            </p>
          </div>
        ) : null}
      </div>
      <Footer />
    </div>
  );
};

export default HelpSearchPage;
